"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var usePixelEvent = function usePixelEvent(eventType, payload) {
  (0, _react.useEffect)(function () {
    if (window.fbq) {
      window.fbq('track', eventType, payload);
    }
  }, []);
  return null;
};

var _default = usePixelEvent;
exports.default = _default;